import React from 'react'
import image from "../../img/user.png"
import { formatMessengerTime } from "./formatMessengerTime";
import HTMLReactParser from "html-react-parser";

export const SingleItem = ({ data, handleReply, HandleShowImage }) => {
    // console.log(data?.adminId?.picture)
    // console.log(data?.images?.length > 0)
    return (
        <>



            {/* user message  */}

            {data?.userId && !data?.adminId && (
                <div className="chat-messages">
                    <div className="messages-right">
                        <div className="message-area">
                            <p className='message-time'>{formatMessengerTime(data?.createdAt)}</p>
                            <div className="message">
                                <p>{data?.text}</p>

                                {data?.images?.length > 0 && (
                                    <div className="image-gallery">
                                        <div className={`gallery gallery-${data?.images.length}`}>
                                            {data?.images.map((data, index) => {
                                                if (!data) return null;

                                                return (
                                                    <div className="image-box" key={index}>
                                                        <img
                                                            src={data}
                                                            alt={`image-${index + 1}`}
                                                            onClick={() => HandleShowImage(data)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                            </div>

                        </div>

                    </div>
                </div>

            )}



            {data?.userId && data?.adminId && (
                <div className="chat-messages">
                    <div className="messages-left">
                        <div className="user-avater">
                            <img src={
                                data?.adminId?.picture
                                    ? `${process.env.REACT_APP_Authorized_API_URL}/${data?.adminId?.picture}`
                                    : image
                            }
                                onError={(e) => (e.target.src = image)} alt="" />
                        </div>

                        <div className="message-area">
                            <div className="user-name">
                                <p>{data?.adminId?.name}</p>
                            </div>
                            <div className="message">
                                {/* <p>{data?.text}</p> */}
                                {data?.text ? HTMLReactParser(data?.text) : ""}


                                {data?.images?.length > 0 && (
                                    <div className="image-gallery ">
                                        <div className={`gallery gallery-${data?.images.length}`}>
                                            {data?.images.map((data, index) => {
                                                if (!data) return null;

                                                return (
                                                    <div className="image-box" key={index}>
                                                        <img
                                                            src={data}
                                                            alt={`image-${index + 1}`}
                                                            onClick={() => HandleShowImage(data)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}


                            </div>
                            <p className='message-time'>{formatMessengerTime(data?.createdAt)}</p>
                        </div>


                    </div>
                </div>

            )}


        </>
    )
}
